/** @format */

export const EditMedium = ({color}) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M17.8413 10.7338L9.63407 18.9383L8.441 17.7451L8.56417 17.6219H6.94173C6.63202 17.6219 6.37862 17.3685 6.37862 17.0587V15.4362L6.2558 15.5593C6.08933 15.7283 5.9672 15.9324 5.90069 16.1577L5.09193 18.9101L7.8427 18.1006C8.03626 18.0337 8.27206 17.9105 8.441 17.7451L9.63407 18.9383C9.26806 19.3043 8.81405 19.5753 8.31782 19.7197L4.08291 20.9656C3.78658 21.0536 3.46596 20.9727 3.24741 20.7228C3.02884 20.5362 2.94713 20.2159 3.03434 19.9168L4.28 15.6825C4.42641 15.1863 4.69494 14.7322 5.06131 14.3662L13.2661 6.1596L17.8413 10.7338ZM20.3401 5.04772C21.22 5.92729 21.22 7.35489 20.3401 8.23482L18.6367 9.93836L14.0615 5.36344L15.7649 3.65989C16.6447 2.78004 18.0736 2.78004 18.9535 3.65989L20.3401 5.04772Z"
                fill={color}
            />
        </svg>
    );
};
